export enum MenuMode {
  Inline = 'inline',
  Horizontal = 'horizontal',
  Vertical = 'vertical'
}
